import { render, staticRenderFns } from "./EducatorInfo.vue?vue&type=template&id=a91b4162"
import script from "./EducatorInfo.vue?vue&type=script&lang=js"
export * from "./EducatorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports